import React, { useState, useEffect, useRef } from 'react';
import { prpHttpAPI } from '../../services/prpHttpAPI';
import styles from './DownloadPdf.module.css';

export const DownloadPdf = () => {
    const [planId, setPlanId] = useState("");
    const [error, setError] = useState("");
    const inputRef = useRef(null); // Create a reference for the input field
    const [password, setPassword] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
  
    const correctPassword = "11332244"; // Set your password here

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === correctPassword) {
          setIsAuthenticated(true);
        } else {
          alert("Wrong password! Try again.");
        }
      };

    // Auto-focus input field on component mount
    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const pdfData = {
        plan_id: planId
    };

    // PDF download function
    const downloadPDF = async (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.download = `${planId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getPdfURL = async () => {
        let returnObj = null;
        try {
            console.log("Fetching PDF URL...");
            const result = await prpHttpAPI(pdfData, 'get-pdf/pdf', null, "POST");
            console.log("Response:", result);
           
                returnObj = result;
            
        } catch (error) {
            console.log("Error downloading PDF:", error.message);
        }
        return returnObj;
    };

    const handleDownload = async () => {
        const result = await getPdfURL();
        if(result.success){
          if (result?.url) {
            await downloadPDF(result.url);
        }
        }else{
          setError(result.error)
        }
      
    };

    return (
        isAuthenticated? 
        <>
            <div className={styles.downloadDiv}>
                <input 
                    ref={inputRef} // Attach ref to input field
                    onChange={(e) => setPlanId(e.target.value)} 
                    value={planId} 
                    type="text" 
                    placeholder='PRP0000225'
                />
                <button className={styles.planBtn} onClick={handleDownload}>Download Pdf</button>
         <p className={styles.error}>{error}</p>
            </div>
        </> :
        (
            <div className={styles.downloadDiv}>
              <h2>Enter Password to Access</h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button className={styles.planBtn} type="submit">Submit</button>
              </form>
            </div>
          )
        
    );
};
